import { useEffect } from 'react'

import { useSetState } from '@domain-group/react-hooks'
import type { UseFormPayload } from '@domain-group/react-hooks'

import type { EntitiesState } from '@redux/entities'

import useGeoStates from '@hooks/useGeoStates'
import useSelector from '@hooks/useSelector'

import type { GeoStateModel } from '@models/types'

type handleCountryStateParams = {
  countryCode: string,
  updatedCountryCode: string,
  setEntityState: Function,
  setState: Function,
}

const handleCountryState = (params: handleCountryStateParams) => {
  const {
    countryCode, updatedCountryCode, setEntityState, setState,
  } = params

  setState({ countryCode: updatedCountryCode })

  if (countryCode !== updatedCountryCode){
    setEntityState({ geo_state_id: undefined })
  }
}

const defaultState = {
  countryCode: '',
}

type UseCreateOrEditSuburbModalPayload = {
  callbacks: {
    handleCountryState: (updatedCountryCode: string) => void,
  },
  countryCode: string,
  filteredGeoStates: GeoStateModel[],
  geoCountries: EntitiesState['geoStates'],
}

interface CreateOrEditSuburbModalProps {
  geoSuburbFormPayload: UseFormPayload,
  geoState: GeoStateModel,
}

const useCreateOrEditSuburbModal = (props: CreateOrEditSuburbModalProps): UseCreateOrEditSuburbModalPayload => {
  const { geoSuburbFormPayload, geoState } = props
  const { setEntityState } = geoSuburbFormPayload
  const { country_code } = geoState

  const [state, setState] = useSetState(defaultState)
  const { countryCode } = state

  // @ts-expect-error TS2353
  const geoStatesPayload = useGeoStates({ filters: { filterCountryCode: countryCode }, performHttpRequests: true })
  const { filteredGeoStates } = geoStatesPayload

  const geoCountries = useSelector(reduxState => reduxState.entities.geoCountries)

  useEffect(() => {
    if (country_code){
      setState({ countryCode: country_code })
    }
  }, [country_code])

  return (
    {
      callbacks: {
        handleCountryState: updatedCountryCode => handleCountryState({
          countryCode, updatedCountryCode, setEntityState, setState,
        }),
      },
      countryCode,
      filteredGeoStates,
      geoCountries,
    }
  )
}

export default useCreateOrEditSuburbModal
